module.exports = __webpack_public_path__ + "static/media/icon-clock.1ab285fc.png";